import { Reducer } from 'redux';

import { ActionTypes } from '../types/action-types';
import { ActionObject, IAuth } from '../types/auth';

export default ((state = {
  accountId: '',
  token: '',
}, action: ActionObject): IAuth => {
  switch (action.type) {
    case ActionTypes.KEY_UPDATED:
      return {
        ...state,
        accountId: action.accountId,
        token: action.token,
      };
    case ActionTypes.TOGGLE_TOKEN_VISIBILITY:
      return {
        ...state,
        showToken: action.showToken,
      };
  }
  return {...state};
}) as Reducer<IAuth>;



// WEBPACK FOOTER //
// ./src/sub-projects/roostify/reducers/auth.ts